/** values for profile that indicate an image service */
const iiifImageProfiles = [
  'level2',
  'level1',
  'level0',
  'http://iiif.io/api/image/2/level2.json',
  'http://iiif.io/api/image/2/level1.json',
  'http://iiif.io/api/image/2/level0.json',
];

export default {
  iiifImageProfiles,
};
